export default __webpack_public_path__ + "static/media/cover.98ab1b0a.webp";